import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { Router } from "@angular/router";
import { ConfirmDialog } from "../ConfirmDialog/confirm-dialog.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";


@Component({
    selector: 'confirm-dialog',
    templateUrl: './controlaccess.component.html',
    styleUrls: ['../ConfirmDialog/confirm-dialog.component.scss'],
    imports: [
        MatIconModule,
        CommonModule,
        MatCheckboxModule,
        FormsModule,
    ],
})
export class ControlAccessDialogComponent {
    account: string;
    constructor(public dialogRef: MatDialogRef<ConfirmDialog>, @Inject(MAT_DIALOG_DATA) public data: { confirmText: string, titleText: string }, private router: Router) { }

    onOkClick(): void {
        window.open('https://meetings.hubspot.com/alexandre-prat-fourcade/clone', '_blank');
    }
}

export function controlAccessPopUp(dialog: MatDialog, titleText: string, confirmText: string) {
    return dialog.open(ControlAccessDialogComponent, {
        disableClose: false,
        autoFocus: false,
        width: "950px",
        height: "fit-content",
        backdropClass: ["backdrop-blur"],
        data: { confirmText: confirmText, titleText: titleText }
    })
}



